import { useApp } from "../../state/store";
import { useT } from "../../i18n/store";
import { buildLayout } from "../../domain/layout";
import { Section } from "../Section";
import { NumberInput } from "../NumberInput";
import { Checkbox } from "../Checkbox";

export const TilingSection = () => {
  const t = useT();
  const tile = useApp((s) => s.tile);
  const setTile = useApp((s) => s.setTile);

  // When tile.auto is on, displayed cols/rows come from the derived layout —
  // not from the stored tile.cols/rows (which are stale until auto is turned off).
  const derived = useApp((s) => buildLayout(s.paper, s.margins, s.sign, s.tile));
  const cols = tile.auto ? derived.cols : tile.cols;
  const rows = tile.auto ? derived.rows : tile.rows;

  const onAutoChange = (auto: boolean) => {
    // When turning auto OFF, freeze the current derived values so the user
    // edits from where they were.
    if (!auto) setTile({ auto: false, cols, rows });
    else setTile({ auto: true });
  };

  return (
    <Section title={t("section.tiling")}>
      <div className="row check">
        <Checkbox label={t("tile.auto")} checked={tile.auto} onChange={onAutoChange} />
      </div>
      <div className="row two">
        <div>
          <label>{t("tile.cols")}</label>
          <NumberInput
            value={cols}
            onChange={(v) => setTile({ cols: Math.max(1, Math.round(v)) })}
            min={1} max={40} step={1} precision={0}
            disabled={tile.auto}
          />
        </div>
        <div>
          <label>{t("tile.rows")}</label>
          <NumberInput
            value={rows}
            onChange={(v) => setTile({ rows: Math.max(1, Math.round(v)) })}
            min={1} max={40} step={1} precision={0}
            disabled={tile.auto}
          />
        </div>
      </div>
    </Section>
  );
};
